export interface UserCommunicationShipper {
  userCommunicationShipperId?: string;
  userCommunicationId: string;
  customerId: string;
}
